import React from 'react';
import {Main} from '../../layouts';
import Container from '../../components/Container';
import {Box, Card, CardMedia, Typography} from '@mui/material';

const IndexView = () => {
    return (
        <Main>
            <Container>

                <Box component={Card} boxShadow={4} height={1} width={1}>
                    <Box
                        component={CardMedia}
                        height={1}
                        width={1}
                        minHeight={300}
                        image={process.env.PUBLIC_URL + '/images/banner.png'}
                    />
                </Box>
                <Box>
                    <Typography variant={'h6'} gutterBottom sx={{fontWeight: 500}}>
                        Plug in your mobile devices with a Vampire Proof Charger!
                    </Typography>
                    <Typography variant={'body2'} gutterBottom>
                        Other chargers continue to suck energy and cost you extra money even when not charging your
                        phone, tablet, or other mobile device. That is known as Vampire Energy Loss. Think about the
                        BILLIONS of chargers plugged in all over the world and you start to understand the problem. This
                        Vampire Proof charger stops sucking energy when your mobile device is completely charged or when
                        a device is not connected to it. That saves energy and money waste! One small change can make a
                        big impact!
                    </Typography>
                    <Typography variant={'h6'} gutterBottom sx={{fontWeight: 500}}>
                        Our charger is Vampire Proof!
                    </Typography>
                    <Typography variant={'body2'}>
                        Plug in your mobile devices with a Vampire Proof Charger!
                        <br/>
                        <br/>
                        It stops sucking energy when your mobile device is completely charged or when a device is not
                        connected to it. That saves energy and money waste! One small change can make a big impact!
                    </Typography>
                </Box>
            </Container>
        </Main>);
};

export default IndexView;